// extracted by mini-css-extract-plugin
export var border = "MissionStatementBlockFlat-module--border--050c5";
export var bordercontainer = "MissionStatementBlockFlat-module--bordercontainer--6745d";
export var bordercontainersmooth = "MissionStatementBlockFlat-module--bordercontainersmooth--28dbe MissionStatementBlockFlat-module--bordercontainer--6745d";
export var bottomheart = "MissionStatementBlockFlat-module--bottomheart--87d4c";
export var buttonwrapper = "MissionStatementBlockFlat-module--buttonwrapper--c1aad";
export var details = "MissionStatementBlockFlat-module--details--e73e6";
export var image = "MissionStatementBlockFlat-module--image--da1fe";
export var middleheart = "MissionStatementBlockFlat-module--middleheart--a8ef2";
export var missionstatementblockcontainer = "MissionStatementBlockFlat-module--missionstatementblockcontainer--0fe1c";
export var oatmeal = "MissionStatementBlockFlat-module--oatmeal--b5679";
export var subheading = "MissionStatementBlockFlat-module--subheading--02430";
export var text = "MissionStatementBlockFlat-module--text--07429";
export var title = "MissionStatementBlockFlat-module--title--c9e40";
export var topheart = "MissionStatementBlockFlat-module--topheart--5ca48";
export var white = "MissionStatementBlockFlat-module--white--72185";
export var yellow = "MissionStatementBlockFlat-module--yellow--0e775";